/* Filter server-rendered motor-capable products; no catalog fetch or price override. */
(() => {
  const start = root => {
    if (root.dataset.kmReady === 'true') return;
    const cards = [...root.querySelectorAll('[data-km-product]')];
    const families = [...root.querySelectorAll('[data-km-family]')];
    const system = root.querySelector('[data-km-system]');
    const search = root.querySelector('[data-km-search]');
    const results = root.querySelector('[data-km-results]');
    const shown = root.querySelector('[data-km-shown]');
    const more = root.querySelector('[data-km-more]');
    const empty = root.querySelector('[data-km-empty]');
    if (!cards.length || !system || !search || !results || !more || !empty) return;
    const knownFamilies = new Set(families.map(button => button.dataset.kmFamily));
    const knownSystems = new Set([...system.options].map(option => option.value));
    const params = new URLSearchParams(location.search);
    let family = knownFamilies.has(params.get('style')) ? params.get('style') : 'all';
    system.value = knownSystems.has(params.get('system')) ? params.get('system') : 'all';
    search.value = (params.get('q') || '').slice(0, 160);
    let limit = 12;
    const updateURL = () => {
      const url = new URL(location.href);
      for (const [key, value] of [['style', family], ['system', system.value], ['q', search.value.trim()]]) {
        if (value && value !== 'all') url.searchParams.set(key, value); else url.searchParams.delete(key);
      }
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    };
    const render = (persist = true) => {
      const terms = search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      const matches = cards.filter(card => (family === 'all' || card.dataset.kmFamilyId === family)
        && (system.value === 'all' || card.dataset.kmSystems.split(' ').includes(system.value))
        && terms.every(term => card.dataset.kmSearch.includes(term)));
      const visible = new Set(matches.slice(0, limit));
      cards.forEach(card => {
        card.hidden = !visible.has(card);
        const link = card.querySelector('[data-km-product-link]');
        if (link) {
          const url = new URL(link.getAttribute('href'), location.origin);
          if (system.value !== 'all' && system.value !== 'remote') url.searchParams.set('motor_system', system.value);
          else url.searchParams.delete('motor_system');
          link.setAttribute('href', url.pathname + url.search);
          const price = card.querySelector('[data-km-price]');
          const priceSystem = url.searchParams.get('motor_system') || 'all';
          const amount = price?.getAttribute(`data-km-price-${priceSystem}`) || price?.getAttribute('data-km-price-all');
          if (price && amount) price.textContent = `Starting at ${amount}`;
        }
      });
      families.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kmFamily === family)));
      results.textContent = `${matches.length} motor-capable ${matches.length === 1 ? 'product' : 'products'}`;
      shown.textContent = `Showing ${Math.min(limit, matches.length)} of ${matches.length}`;
      more.hidden = matches.length <= limit;
      empty.hidden = matches.length > 0;
      if (persist) updateURL();
    };
    families.forEach(button => button.addEventListener('click', () => { family = button.dataset.kmFamily; limit = 12; render(); }));
    system.addEventListener('change', () => { limit = 12; render(); });
    search.addEventListener('input', () => { limit = 12; render(); });
    root.querySelectorAll('[data-km-reset]').forEach(button => button.addEventListener('click', () => { family = 'all'; system.value = 'all'; search.value = ''; limit = 12; render(); }));
    root.querySelectorAll('[data-km-control-filter]').forEach(link => link.addEventListener('click', () => { system.value = link.dataset.kmControlFilter; family = 'all'; search.value = ''; limit = 12; render(); }));
    more.addEventListener('click', () => { const before = limit; limit += 12; render(false); const visible = cards.filter(card => !card.hidden); visible[before]?.querySelector('[data-km-product-link]')?.focus({preventScroll:false}); });
    root.querySelectorAll('[data-km-js]').forEach(el => { el.hidden = false; });
    root.dataset.kmReady = 'true';
    render(false);
  };
  const initialize = () => document.querySelectorAll('[data-kalia-motorization]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
